module.exports = __webpack_public_path__ + "img/custom_size_img.0e77327f.png";